export type ReportOption = {
  label: string
  value: number
}

export const REPORT_OPTIONS: ReportOption[] = [
  { label: 'Period completed by tagger', value: 1 },
  { label: 'Game completed period', value: 2 },
]

export const getReportLabel = (value: number) =>
  REPORT_OPTIONS.find((o) => o.value === value)?.label ?? String(value)
